import FormElement from '../../form/FormElement/FormElement';
import styles from './styles.module.scss';
import classNames from 'classnames';
import React, {useId, useState} from 'react';
import {useTranslation} from 'react-i18next';

interface ITextFieldProps {
  className?: string;
  id?: string;
  type: string;
  name: string;
  value: string | number;
  fullWidth?: boolean;
  error?: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  onBlur?: (e: React.FocusEvent<any>) => void;
  onKeyDown?: (e: React.KeyboardEvent<any>) => void;
  required?: boolean;
  labelText?: string;
  small?: boolean;
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: number;
  autoComplete?: string;
  role?: string;
  icon?: React.ReactNode;
  iconClickHandler?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  lngKey?: string;
  isAutofillСomplete?: boolean;
  maxLength?: number;
  showCount?: boolean;
}

const TextField = ({
  className,
  id,
  type = 'text',
  value,
  fullWidth,
  error,
  onChange,
  onBlur,
  onKeyDown,
  labelText,
  required,
  small,
  name,
  disabled,
  min,
  max,
  step,
  autoComplete,
  role,
  icon,
  iconClickHandler,
  lngKey = '',
  isAutofillСomplete,
  maxLength,
  showCount,
}: ITextFieldProps) => {
  const [isActive, setIsActive] = useState(false);
  const formId = id ?? useId();
  const {t} = useTranslation();

  const cn = classNames(
    styles.input,
    error && styles.error,
    disabled && styles.disabled,
    small && styles.small,
    className,
  );

  const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e);
    }
    setIsActive(false);
  };

  return (
    <FormElement
      required={required}
      fullWidth={fullWidth}
      error={error}
      isActive={isActive}
      hasValue={isAutofillСomplete ?? value !== ''}
      labelText={labelText || t(lngKey)}
      id={formId || name}
      small={small}
      disabled={disabled}
    >
      <input
        className={cn}
        id={formId || name}
        name={name}
        type={type}
        onChange={onChange}
        onKeyDown={onKeyDown}
        value={value}
        onFocus={() => setIsActive(true)}
        onBlur={blurHandler}
        data-cy='input'
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        autoComplete={autoComplete ?? 'on'}
        role={role}
        maxLength={maxLength}
      />
      {maxLength && showCount && <span className={styles.count}>{`${String(value).length} / ${maxLength}`}</span>}
      <span className={styles.icon} onClick={iconClickHandler}>
        {icon}
      </span>
    </FormElement>
  );
};

export default TextField;
